export const SET_PAYMENT_METHODS_PROCESSING = 'SET_PAYMENT_METHODS_PROCESSING'
export const SET_PAYMENT_METHODS = 'SET_PAYMENT_METHODS'
export const SET_PAYMENT_DATA_PROCESSING = 'SET_PAYMENT_DATA_PROCESSING'
export const SET_PAYMENT_DATA = 'SET_PAYMENT_DATA'
export const RESET_PAYMENT_METHODS = 'RESET_PAYMENT_METHODS'
export const RESET_PAYMENT_DATA = 'RESET_PAYMENT_DATA'
export const SET_PAYMENT_ERROR = 'SET_PAYMENT_ERROR'
export const RESET_PAYMENT_ERROR = 'RESET_PAYMENT_ERROR'
export const SET_PAYMENT_TEST_CODE = 'SET_PAYMENT_TEST_CODE'
export const RESET_PAYMENT_TEST_CODE = 'RESET_PAYMENT_TEST_CODE'
export const SET_PAYMENT_AUTHORIZATION = 'SET_PAYMENT_AUTHORIZATION'
export const SET_PAYMENT_BILLING_INFO = 'SET_PAYMENT_BILLING_INFO'

export function setPaymentMethodsProcessing (processing) {
  return {
    type: SET_PAYMENT_METHODS_PROCESSING,
    payload: processing,
  }
}

export function setPaymentMethods (data, processing = false) {
  return {
    type: SET_PAYMENT_METHODS,
    payload: { data, processing },
  }
}

export function resetPaymentMethods () {
  return {
    type: RESET_PAYMENT_METHODS,
  }
}

export function setPaymentDataProcessing (processing) {
  return {
    type: SET_PAYMENT_DATA_PROCESSING,
    payload: processing,
  }
}

export function setPaymentData (data, processing = false) {
  return {
    type: SET_PAYMENT_DATA,
    payload: { data, processing },
  }
}

export function resetPaymentData () {
  return {
    type: RESET_PAYMENT_DATA,
  }
}

export function setPaymentError (error, processing = false) {
  return {
    type: SET_PAYMENT_ERROR,
    payload: { error, processing },
  }
}

export function resetPaymentError () {
  return {
    type: RESET_PAYMENT_ERROR,
  }
}

export function setPaymentTestCode (value) {
  return {
    type: SET_PAYMENT_TEST_CODE,
    payload: value,
  }
}

export function resetPaymentTestCode () {
  return {
    type: RESET_PAYMENT_TEST_CODE,
  }
}

export function setPaymentAuthorization (data) {
  return {
    type: SET_PAYMENT_AUTHORIZATION,
    payload: data,
  }
}

export function setPaymentBillingInfo (data) {
  return {
    type: SET_PAYMENT_BILLING_INFO,
    payload: data,
  }
}
